import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Calendar } from "lucide-react";
import dayjs from 'dayjs';

export default function NewsList() {
  const [news, setNews] = useState([]);
  const [filteredNews, setFilteredNews] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [selectedTag, setSelectedTag] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/news/all`)
      .then((res) => res.json())
      .then((data) => {
        setNews(data);
        setFilteredNews(data);
      });
  }, []);

  useEffect(() => {
    let result = news;

    if (keyword) {
      result = result.filter(
        (item) =>
          item.title.includes(keyword) ||
          item.summary.includes(keyword) ||
          item.content.includes(keyword)
      );
    }

    if (selectedTag) {
      result = result.filter((item) => item.tags.includes(selectedTag));
    }

    if (date) {
      result = result.filter((item) =>
        item.date.startsWith(date) // YYYY-MM-DD
      );
    }

    setFilteredNews(result);
  }, [news, keyword, selectedTag, date]);

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-6">
      <div className="flex flex-col md:flex-row gap-4 items-center">
        <Input
          placeholder="輸入關鍵字..."
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          className="w-full md:w-2/3 p-6 space-y-6"
        />
        {/* <Input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="w-full md:w-1/3"
        /> */}
        <Button>搜尋</Button>
      </div>

      <div className="grid gap-6">
        {filteredNews.map((item) => (
          <Card key={item.id} className="shadow-md hover:shadow-lg transition">
            <CardHeader>
              <CardTitle className="text-xl">{item.title}</CardTitle>
              <p className="text-sm text-gray-500 flex items-center gap-1">
                <Calendar className="w-4 h-4" />
                {dayjs(item.date).format("YYYY/MM/DD")}
                {/* <span className="ml-2">作者: {item.author}</span> */}
              </p>
            </CardHeader>
            <CardContent>
              {/* 顯示摘要 */}
              <p className="mb-3">{item.summary}</p>
              <div className="flex flex-wrap gap-2 mb-4">
                {item.tags.map((tag, i) => (
                  <Badge
                    key={i}
                    variant="secondary"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedTag(tag);
                      setKeyword("");
                      setDate("");
                    }}
                    className="cursor-pointer"
                  >
                    #{tag}
                  </Badge>
                ))}
              </div>
              
              {/* 分隔線 */}
              <hr className="my-4 border-t border-gray-200" />
              
              {/* 直接顯示內文，並使用灰色文字 */}
              <div className="mt-4 text-gray-500">
                {item.content}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
